import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {getBlogContent} from '@/content/blog/blog'
import {useTranslation} from '@/i18n'
import {BLOG_HERO_IMAGE_HEIGHT_DESKTOP, BLOG_HERO_IMAGE_HEIGHT_MOBILE} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {MetricsList} from './MetricsList'

type KeyMetricsProps = {
  title?: string
  description?: string
  importance: number
  willingness: number
}

export const KeyMetrics: FC<React.PropsWithChildren<KeyMetricsProps>> = ({
  title,
  description,
  importance,
  willingness,
}) => {
  const {t} = useTranslation()
  const {metrics} = getBlogContent()

  return (
    <>
      <div className="wrapper">
        <Text variant={TextVariant.h2}>{title || t(metrics.title)}</Text>
        <div className="description">
          <Text variant={TextVariant.text20}>{description || t(metrics.description)}</Text>
        </div>
      </div>
      <MetricsList importance={importance} willingness={willingness} />

      <style jsx>{`
        .wrapper {
          max-width: 630px;
        }
        .description {
          margin-top: ${theme.spacing[3.5]};
        }
        @media ${TABLET_SCREENSIZE} {
          .wrapper {
            max-width: inherit;
            text-align: center;
            margin-top: calc(${BLOG_HERO_IMAGE_HEIGHT_DESKTOP} / 2);
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .wrapper {
            margin-top: calc(${BLOG_HERO_IMAGE_HEIGHT_MOBILE} / 2);
          }
        }
      `}</style>
    </>
  )
}
